import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  getGuidelinesUrl,
  termsOfServiceUrls,
  privacyPolicyUrls,
} from "constants/links";
import { THAI_FONT_FAMILY } from "theme/thaiButtonStyles";

const Footer = ({ soulId }) => {
  const { t, i18n } = useTranslation(["chi"]);
  const navigate = useNavigate();

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const lng = params.get("lng") || "ja";

  // ルートに ?lng=xx をつける
  const withLng = (path) => {
    const hasQuery = path.includes("?");
    return lng ? `${path}${hasQuery ? "&" : "?"}lng=${lng}` : path;
  };

  const links = [
    {
      label: `${t("chi:Footer.my_page")}`,
      path: `/chi/mypage?soul_id=${soulId}`,
    },
    {
      label: `${t("chi:Footer.quests")}`,
      path: `/chi/quests?soul_id=${soulId}`,
    },
    {
      label: `${t("chi:Footer.purchase_ticket")}`,
      path: `/chi/tickets?soul_id=${soulId}`,
    },
    {
      label: `${t("chi:Footer.how_to_play")}`,
      path: `/chi/how-to-use?soul_id=${soulId}`,
    },
    { label: `${t("chi:Footer.news")}`, path: `/chi/news?soul_id=${soulId}` },
    {
      label: `${t("chi:Footer.contact")}`,
      url: "https://line.me/R/ti/p/@314jdaww",
    },
    {
      label: `${t("chi:Footer.guidelines")}`,
      url: getGuidelinesUrl("chi", lng),
    },
    {
      label: `${t("chi:Footer.terms_of_service")}`,
      url: termsOfServiceUrls[lng],
    },
    { label: `${t("chi:Footer.privacy_policy")}`, url: privacyPolicyUrls[lng] },
  ];

  const commonStyles = {
    cursor: "pointer",
    transition: "color 0.2s, transform 0.2s",
    "&:hover": { color: "lightgray", transform: "scale(1.05)" },
    "&:active": { color: "gray", transform: "scale(0.95)" },
  };

  return (
    <Box
      sx={{
        ...(lng.startsWith("th") && {
          "--thai-font-family": THAI_FONT_FAMILY,
        }),
        backgroundColor: "transparent",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        pt: 5,
        pb: 12,
        color: "white",
      }}
    >
      {links.map((link, index) => (
        <Typography
          key={index}
          fontFamily='"Noto Serif JP", serif'
          fontSize="16px"
          fontWeight={lng.startsWith("th") ? 500 : "bold"}
          sx={commonStyles}
          onClick={
            link.path
              ? () => navigate(withLng(link.path))
              : link.url
              ? () => {
                  window.open(link.url, "_blank");
                }
              : undefined
          }
        >
          {link.label}
        </Typography>
      ))}

      {/* <Typography fontFamily='"Noto Serif JP", serif' fontSize="12px" fontWeight="bold" mt={4} whiteSpace={"pre-line"} textAlign="center">
        {"Ⓒ魚豊／小学館／チ。ー地球の運動についてー製作委員会\nⒸSekaiE Inc."}
      </Typography> */}
    </Box>
  );
};

export default Footer;
